import { useState, useEffect } from 'react';
import { authService, type AuthUser } from '../services/auth';

export const useAuth = () => {
  const [user, setUser] = useState<AuthUser | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadUser = async () => {
      try {
        const currentUser = await authService.getCurrentUser();
        setUser(currentUser);
      } catch (error) {
        console.error('Error loading user:', error);
        setUser(null);
      } finally {
        setLoading(false);
      }
    };

    loadUser();

    const handleAuthChanged = (event: Event) => {
      const detail = (event as CustomEvent<{ user?: AuthUser | null }>).detail;
      if (detail?.user != null) {
        setUser(detail.user);
        setLoading(false);
        return;
      }
      setLoading(true);
      loadUser();
    };
    window.addEventListener('auth:changed', handleAuthChanged);
    return () => window.removeEventListener('auth:changed', handleAuthChanged);
  }, []);

  const signOut = async () => {
    await authService.signOut();
    setUser(null);
  };

  return { user, loading, signOut };
};
